/**
 * Strategic Management session storage keys
 */
export const STRATEGIC_STORAGE_KEY = {
  PORTFOLIO_NOTES_ID: 'STRATEGIC_PORTFOLIO_NOTES_ID',
  // Portfolio Overview - Pipeline Calendar scroll position
  PORTFOLIO_PIPELINE_CALENDAR_SCROLL: 'STRATEGIC_PORTFOLIO_PIPELINE_CALENDAR_SCROLL',
  // Studios - Pipeline Calendar scroll position
  STUDIOS_PIPELINE_CALENDAR_SCROLL: 'STRATEGIC_STUDIOS_PIPELINE_CALENDAR_SCROLL',
  
  // Studios - Notes scroll position
  STUDIOS_NOTES_ID: 'STRATEGIC_STUDIOS_NOTES_ID',
  
  // In Dev Projects - GR Management scroll position
  INDEV_GR_MANAGEMENT_ID: 'STRATEGIC_INDEV_GR_MANAGEMENT_ID',
  
  // In Dev Projects - Notes scroll position
  INDEV_NOTES_ID: 'STRATEGIC_INDEV_NOTES_ID',
  
  // Weekly Project Highlight - Project scroll position
  WEEKLY_PROJECT_HIGHLIGHT_PROJECT_ID: 'STRATEGIC_WEEKLY_PROJECT_HIGHLIGHT_PROJECT_ID',
  
  // Publishing Project - Review scroll position
  PUBLISHING_PROJECT_REVIEW_ID: 'STRATEGIC_PUBLISHING_PROJECT_REVIEW_ID',
};
